import React from 'react';
import ReactDOM from 'react-dom/client';
import 'dailywork-shared-theme/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Handle ResizeObserver loop error
const resizeObserverErrHandler = (error) => {
  if (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    error.stopImmediatePropagation();
  }
};

window.addEventListener('error', resizeObserverErrHandler);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
